// numberFormat.js - 숫자 포맷팅 유틸리티 함수
/**
 * 숫자를 3자리마다 콤마로 구분하여 포맷팅
 * @param {number|string} number - 포맷팅할 숫자
 * @returns {string} - 포맷팅된 문자열 (예: "13,945,815")
 */
export const formatNumber = (number) => {
  // 숫자가 아닌 경우 처리
  if (number === null || number === undefined || number === '') {
    return '0';
  }
  
  // 문자열인 경우 숫자로 변환
  const num = typeof number === 'string' ? parseFloat(number) : number;
  
  // NaN인 경우 0 반환
  if (isNaN(num)) {
    return '0';
  }
  
  // 정수로 변환 (소수점 제거)
  const integer = Math.floor(num);
  
  // 3자리마다 콤마 추가
  return integer.toLocaleString('en-US');
};

/**
 * 포인트 표시용 포맷팅 (에그 카운터 전용)
 * @param {number|string} points - 포인트 수
 * @returns {string} - 포맷팅된 포인트 문자열
 */
export const formatPoints = (points) => {
  return formatNumber(points);
};

/**
 * 큰 숫자 표시용 포맷팅 (K, M 단위 포함)
 * @param {number|string} number - 포맷팅할 숫자
 * @returns {string} - 포맷팅된 문자열 (예: "1.2M", "945K")
 */
export const formatLargeNumber = (number) => {
  const num = typeof number === 'string' ? parseFloat(number) : number;
  
  if (isNaN(num) || num === 0) {
    return '0';
  }
  
  // 1백만 이상
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  
  // 1천 이상
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  }
  
  // 1천 미만은 그대로 표시
  return num.toString();
};

export default {
  formatNumber,
  formatPoints,
  formatLargeNumber
};
